import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SzActionRowComponent, SzBottomSheetComponent, SzIconButtonComponent } from '@ui';
import { QuickStartSheetService } from '../quick-start-sheet.service';
import { QuickStartViewModel } from '../models/quick-start.view-model';

@Component({
  selector: 'lib-fab-quick-start-sheet',
  templateUrl: './fab-quick-start-sheet.component.html',
  styleUrls: ['./fab-quick-start-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, SzBottomSheetComponent, SzActionRowComponent, SzIconButtonComponent]
})
export class FabQuickStartSheetComponent {
  private readonly sheet: QuickStartSheetService = inject(QuickStartSheetService);

  readonly open: Signal<boolean> = this.sheet.open;
  readonly loading: Signal<boolean> = this.sheet.loading;
  readonly viewModel: Signal<QuickStartViewModel | null> = this.sheet.viewModel;

  readonly titleKey: Signal<string> = computed((): string => {
    const variant: 'plan' | 'drills' | 'empty' | undefined = this.viewModel()?.variant;
    if (variant === 'empty') return 'fabQuickStart.titleEmpty';
    return 'fabQuickStart.titleWhatNow';
  });

  onClose(): void {
    this.sheet.hide();
  }

  startTodayPlan(): void {
    const planId: string | undefined = this.viewModel()?.todayPlan?.id;
    if (planId === undefined) return;
    this.sheet.dispatch({ kind: 'start-today-plan', planId });
  }

  startFromDrills(): void {
    this.sheet.dispatch({ kind: 'start-from-drills' });
  }

  repeatLastDrill(): void {
    const drillId: string | undefined = this.viewModel()?.lastDrill?.drillId;
    if (drillId === undefined) return;
    this.sheet.dispatch({ kind: 'repeat-last-drill', drillId });
  }

  createPlan(): void {
    this.sheet.dispatch({ kind: 'create-plan' });
  }

  createDrill(): void {
    this.sheet.dispatch({ kind: 'create-drill' });
  }
}
